import React from 'react';
import ReactDOM from 'react-dom';
import {
  LikeButton,
  LikeButtonProps,
  ReactionToggleIcon,
  ReactionIconProps,
  useFeedContext,
} from 'react-activity-feed';
import { HeartOutlineIcon, HeartSolidIcon, Color } from './Icons';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';

const TigerLikeButton: React.FunctionComponent<LikeButtonProps> = (props) => {
  // We can set some particular props to have default values if we want
  // props = Object.assign({ propOne: 'value', propTwo: 'value' }, props)

  // Child inside this is not working. WHY ???
  // return (
  //   <LikeButton {...props}>
  //     {props.children}
  //     <h3>Sumeet debug inside TigerLikeButton</h3>
  //   </LikeButton>
  // );

  const feed = useFeedContext();

  React.useEffect(() => {
    if (!props.reaction && !props.activity)
      console.warn(
        'LikeButton requires an activity or reaction to work properly'
      );
    if (props.reaction && props.activity)
      console.warn(
        'LikeButton requires only one of the activity or reaction to work properly'
      );
  }, []);

  return (
    <ReactionToggleIcon
      className={props.className}
      style={props.style}
      counts={
        props.reaction?.children_counts ?? props.activity?.reaction_counts
      }
      own_reactions={
        props.reaction?.own_children ?? props.activity?.own_reactions
      }
      kind='like'
      onPress={() => {
        if (props.reaction)
          return feed.onToggleChildReaction('like', props.reaction as any);
        if (props.activity)
          return feed.onToggleReaction('like', props.activity as any);
        return Promise.resolve();
      }}
      activeIcon={<FavoriteIcon style={{ color: Color.Active }} />}
      inactiveIcon={<FavoriteBorderIcon style={{ color: Color.Inactive }} />}
      labelSingle='like'
      labelPlural='likes'
    />
  );
};

export default TigerLikeButton;
